import StarRatingActionButton from '@/components/StarRatingActionButton';
import {prepareApiUrl} from '@/helper/UrlHelper';
export default {
  components: {
    CustomBigTitle: () => import('@/components/CustomBigTitle'),
    NoDataToShow: () => import('@/components/elements/NoDataToShow'),
    StarRatingActionButton,
  },
  props: {
    section: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      organizations: [],
      total: 0,
      loader: false,
    };
  },
  mounted() {
    this.getOrganizations();
  },
  methods: {
    logoUrl(organization) {
      if (organization) {
        return prepareApiUrl(process.env.NUXT_ENV_LEGACY_AGENCY_LOGO_URL, {
          routeParameters: {
            id: organization.id,
          },
          getParameters: {},
        });
      }
    },
    async getOrganizations() {
      const params = new URLSearchParams();
      const legacyIds = this.section.organization_legacy_ids.split(',');
      const legacyIdsArray = [];
      legacyIds.forEach((id) => {
        params.append('legacyId[]', id.replace(/ /g, ''));
        legacyIdsArray.push(+id);
      });
      params.append('itemsPerPage', '100');
      const obj = decodeURI(params.toString());
      await this.$store
        .dispatch('api/organization/getTopOrganizations', obj)
        .then((result) => {
          this.organizations = result.data.sort(
            (a, b) =>
              legacyIdsArray.indexOf(+a.legacyId) -
              legacyIdsArray.indexOf(+b.legacyId)
          );
          this.total = result.totalItems;
          this.loader = true;
        });
    },
  },
};
